
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/junk-removal",
      function () {
        return require("private-next-pages/junk-removal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/junk-removal"])
      });
    }
  